export const STUDENT_STATUSES = ["Active", "Completed", "On Hold", "Cancelled", "Placed"];
export const MODES = ["Online", "Offline"];
export const PAYMENT_STATUSES = ["Pending", "Partial", "Paid"];
export const GENDERS = ["Male", "Female", "Other"];
export const DOC_TYPES = ["Aadhar Card", "PAN Card", "Resume", "Degree", "Experience Letter", "Offer Letter", "Other Documents"];

export const STATUS_STYLE = {
  Active: "bg-primary/10 text-primary",
  Completed: "bg-accent/15 text-green-700",
  "On Hold": "bg-amber-100 text-amber-700",
  Cancelled: "bg-rose-100 text-rose-700",
  Placed: "bg-violet-100 text-violet-700",
};

export const PAYMENT_STYLE = {
  Pending: "bg-rose-100 text-rose-700",
  Partial: "bg-amber-100 text-amber-700",
  Paid: "bg-accent/15 text-green-700",
};

export const fmtMoney = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n || 0);
